export function verifyUrl() {
    if (location.href.indexOf('#') > 0) {
        var arr_url = location.href.split("#")
        if (arr_url[0].indexOf('?') > 0) {
            var new_pattern = /\?([\s\S]*)#/;
            location.href = location.href.replace(new_pattern, '#');
        }
    }
}
